import type { BulkApprovalWorkflowResult } from '@risksmart-app/trpc/src/helpers/run-bulk-approval-workflow';
import type { DeleteActionsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteActionsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteActions = createMutationHook({
  name: 'deleteActions',
  isChangeRequestGated: true,
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.action.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  // The confirmed replay partitions the batch; surface any created or amended
  // change requests on the CR read feeds immediately.
  refreshChangeRequestFeedsWhen: (result: BulkApprovalWorkflowResult) =>
    result.changeRequestIds.length > 0,
  invalidate: (trpc) => [
    trpc.frontend.action.register.queryKey(),
    trpc.frontend.action.actionById.queryKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  // On confirmed replay, `applied` carries the rows actually deleted and gated
  // rows come back in `changeRequestIds`. The legacy GraphQL shape only reports
  // the deleted count.
  mapResponse: (result: BulkApprovalWorkflowResult): DeleteActionsMutation => ({
    deleteActionsById: {
      __typename: 'GenericMutationOutput',
      affected_rows: result.applied.length,
    },
  }),
  graphqlDocument: DeleteActionsDocument,
  graphqlVariables: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  evictFields: ['action', 'action_aggregate'],
});
